// 用于全局存储一些常用的公共数据，如用户名，用户id，开发者中心开关状态，存在sessionStorage中容易被用户手动修改，所以暂存在这里
// 需要存session的可以在这里加，在要使用的地方引入
// userInfo 在退出登录的时候要清空
import axios from '@/plugins/axios'

const userInfo = new Proxy({}, {
  get (target, p, receiver) {
    // 获取值的时候如果没有就去请求，并返回一个空值，所以第一次需要一个不存在的值的时候不能依赖这里
    if (!Reflect.has(target, p)) {
      getUserInfo(p)
      return ''
    }
    return Reflect.get(target, p)
  }
})

/**
 * @param {string} key 需要的对象的key
 * */
async function getUserInfo (key) {
  let defaultKeys = []
  if (!key) {
    // 初始化没有要获取的值的时候默认获取以下几项 name:当前用户名， id:当前用户id
    defaultKeys = ['name', 'id']
  }
  let currentUserInfo = await axios.get('/auth-api/oauth/currentUserInfo')
  if (key) {
    // 取过一次的值全局保存不需要再次请求
    userInfo[key] = currentUserInfo.data[key]
  } else {
    defaultKeys.forEach(item => {
      userInfo[item] = currentUserInfo.data[key]
    })
  }
}
export { userInfo, getUserInfo }



// WEBPACK FOOTER //
// ./src/store/app-common-data/userInfo.js